import { render } from "./TbRow.vue?vue&type=template&id=7b98536d"
import script from "./TbRow.vue?vue&type=script&lang=js"
export * from "./TbRow.vue?vue&type=script&lang=js"
script.render = render

export default script